import { Injectable } from '@angular/core';

@Injectable()
export class ElementHelperService {

    focusById(elementId: string) {
        setTimeout(() => {
            const element = document.getElementById(elementId);

            if (element) element.focus();
        }, 0);
    }
}
